var map = {
	"./en": [
		"4f5e",
		"locale-0"
	],
	"./en.json": [
		"4f5e",
		"locale-0"
	],
	"./vi": [
		"c3cd"
	],
	"./vi.json": [
		"c3cd"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a09d";
module.exports = webpackAsyncContext;